import React, { Component, Fragment } from 'react';
import MasterStringsListItem from './MasterStringsListItem.js';

class MasterStringsList extends Component {
  constructor (props) {
    super(props);

    this.state = {
      unsavedChanges: false,
      availableContexts: [],
      isSaving: false
    };

    this.formRef = React.createRef();
    this.contentRef = React.createRef();
    this.originalValues = this.loadValuesAsOriginal(this.props.strings);
    this.onSubmit = this.onSubmit.bind(this);
    this.markUnsavedChanges = this.markUnsavedChanges.bind(this);
  }

  loadValuesAsOriginal (strings, mode) {
    const that = this;
    let values = {};

    strings.map(function (string) {
      values[string.props.key] = {
        context: string.props.context,
        description: string.props.description
      }
    });

    return values;
  }

  componentDidMount () {
    this.determineAvailableContexts(this.props.strings);
  }

  onSubmit (e) {
    const that = this;

    this.setState({ isSaving: true });

    e.preventDefault();

    let updated = this.props.updater(this.props.strings);
    if (updated) {
      updated.then(function () {
        that.props.strings.map(function (string) {
          string.props.isDirty = false;
        });
        that.originalValues = that.loadValuesAsOriginal(that.props.strings);
        that.setState({ unsavedChanges: false, isSaving: false });
        that.determineAvailableContexts(that.props.strings);
      });
    }
  }

  markUnsavedChanges () {
    const that = this;
    let isDirty = false;

    this.props.strings.map(function (string) {
      if (string.props.isDirty) {
        isDirty = true;
      }
    });

    if (isDirty !== this.state.unsavedChanges) {
      this.setState({ unsavedChanges: isDirty });
    }
  }

  componentWillChangeProps (nextProps) {
    this.determineAvailableContexts(nextProps.strings);
  }

  determineAvailableContexts (strings) {
    let contexts = [];

    strings.map(function (string) {
      if (string.props.context) {
        contexts.push(string.props.context);
      }
    });

    this.setState({
      availableContexts: Array.from(new Set(contexts))
    });
  }
  
  render () {
    let strings = null;
    const that = this;

    if (this.props.strings.length) {
      strings = this.props.strings.map(function (string) {
        return (
          <MasterStringsListItem 
            changesBeacon={that.markUnsavedChanges} 
            key={string.props.key} 
            string={string}
            container={that.contentRef}
            originals={{
              context: that.originalValues[string.props.key].context ? that.originalValues[string.props.key].context : "",
              description: that.originalValues[string.props.key].description ? that.originalValues[string.props.key].description : ""
            }}
            availableContexts={that.state.availableContexts}
            isSaving={(that.state.isSaving === true && string.props.isDirty === true)}
          />
        );
      });
    }

    return (
      <Fragment>
        <div className="title">
          <span className="title-content">
            <h1>Editing Master File</h1>
          </span>
        </div>
        <form ref={this.formRef} onSubmit={that.onSubmit} key="master.strings.list.form">
          <div ref={this.contentRef} className="content">
            <div className="table-container">
              <table className="table is-fullwidth is-hoverable is-striped is-scrollable" style={{tableLayout: 'fixed'}} >
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Master</th>
                    <th>Context</th>
                    <th>Description</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {strings}
                </tbody>
              </table>
            </div>
          </div>
          <div className="bottom">
            <div className="level">
              <div className="level-left">
              </div>
              <div className="level-right">
                <span className="level-item">
                  <input 
                    disabled={this.state.isSaving || !this.state.unsavedChanges} 
                    type="submit" 
                    onSubmit={that.onSubmit} 
                    value={this.state.isSaving ? 'Saving...' : 'Save Changes'}
                    className="button is-primary is-gradient" 
                  />
                </span>
              </div>
            </div>
          </div>
        </form>
      </Fragment>
    );
  }
}

export default MasterStringsList;


// WEBPACK FOOTER //
// ./src/Components/MasterStringsList.js